import { useCallback, useState } from "react";

/**
 * Контролируемая вкладка: локальное состояние синхронизируется с
 * внешним наблюдателем через onTabChange.
 *
 * Зачем отдельный хук, а не две строки в каждой модалке: правило
 * «переключили вкладку → сообщили наверх» - одно и то же у карточки
 * задачи и карточки проекта. Дублирование мелкое, но именно оно
 * приводит к расхождению поведения, когда в третьей модалке кто-то
 * забудет про onTabChange.
 *
 * Проп onTabChange необязателен: модалка работает и без него -
 * тогда вкладка живёт только локально, как раньше.
 *
 * Возвращает кортеж, зеркалящий useState: [tab, changeTab].
 * Обратите внимание - не [tab, setTab]: наружу отдаётся функция,
 * которая обязана уведомить наблюдателя, а не «сырой» setState.
 * Это делает невозможной ошибку «забыли вызвать onTabChange».
 *
 * initialTab читается один раз при монтировании - как и в useState.
 * Если родитель поменяет проп после маунта, вкладка не переедет;
 * для наших модалок это корректное поведение.
 */
export function useControlledTab(initialTab, onTabChange) {
  const [tab, setTab] = useState(initialTab);

  const changeTab = useCallback(
    (id) => {
      setTab(id);
      onTabChange?.(id);
    },
    [onTabChange],
  );

  return [tab, changeTab];
}
